/* eslint-disable no-console */
import { Auth, Constants, Project } from '@leverege/api-redux';
import MoltenUtil from "../../MoltenUtil.js";
import MoltenConstants from "../../Constants.js"; // import { cleanupPreload } from '../../preload'
const {
  LOGGED_IN,
  LOGGED_OUT
} = MoltenConstants;

/**
 * Creates and installs the ApiProvider
 */
export default {
  id: 'molten.AuthInit',
  sort: 0,
  createMiddleware: molten => {
    return store => next => action => {
      // Trigger onLoggedIn Plugins. Wait for them to return
      // before sending the action
      if (action.type === Constants.AUTH_LOGGED_IN) {
        // Run the on logged in calls
        return MoltenUtil.invokeMoltenCallbacks(LOGGED_IN, 'onLoggedIn', molten, action).then(() => {
          next(action);
          // TODO: Move to HTML version
          // cleanupPreload()
        }, err => {
          console.error(err);
          // TODO: we might want to logout and redirect to error page here
          next(action);
        });
      }

      // Trigger onLoggedOut Plugins. Wait for them to return
      // before sending the action
      if (action.type === Constants.AUTH_LOGGED_OUT) {
        // Run the on logged out calls
        return MoltenUtil.invokeMoltenCallbacks(LOGGED_OUT, 'onLoggedOut', molten).then(() => {
          next(action);
        }, err => {
          console.error(err);
          next(action);
        });
      }
      return next(action);
    };
  },
  /**
   * Kick off the check to see if the user's credentials are still valid
   */
  onPrerender: async molten => {
    const store = molten.get('store');
    const api = molten.get('api');
    if (window?.location?.pathname === '/') {
      const q = new URLSearchParams(window.location.search);
      const token = q.get('token');
      const userCode = q.get('userCode');
      if (token) {
        api.setToken(token);
        if (userCode) {
          store.dispatch(Auth.setUserCode(userCode));
          store.dispatch(Auth.renew());
        }
      }
    }
    try {
      await store.dispatch(Auth.verify());
    } catch (e) {
      console.error(e);
    }
    try {
      await store.dispatch(Project(api.options.projectId).oidcClients().list());
    } catch (e) {
      console.error(e);
    }
  }
};